import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import { fireEvent, getTrackingId } from '../../cra'
import { useEffect, useState } from 'react'

import { PulseLoader } from 'react-spinners'
import Slider from 'react-slick'
import styled from '@emotion/styled'

interface LoaderProps {
  message?: string
  contents?: string[]
  leadBrand?: string
  pageName?: string
}

const Container = styled.div`
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;

  @media screen and (max-width: 750px) {
    width: 320px;
  }

  @media screen and (max-width: 380px) {
    width: 290px;
  }

  @media screen and (max-width: 280px) {
    width: 230px;
    height: 300px;
  }

  .slick-prev: before {
    color: black !important;
  }

  .slick-next: before {
    color: black !important;
  }
`

const GatheringInfoParagraph = styled.div`
    color: rgb(186, 0, 0);
    margin-top: 20px;
    font-size: 24px;
    font-weight: 650;
    padding: 0px 20px;
    font-family: "Inter", sans-serif !important;
}
`

const SliderContainer = styled.div`
  color: #222c69;
  text-align: center;
  padding-top: 20px;
  padding-bottom: 40px;
`
const SliderHeading = styled.div`
  color: #222c69;
  text-align: center;
  padding-top: 20px;
`
const TextContainer = styled.div`
  // line-height: 1.5;
  text-align: center;
`

const LogoContainer = styled.div`
  margin-top: -2px;
  max-width: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    max-width: 180px;
    max-height: 80px;
    width: 100%;
    height: 100%;
  }
`

const Loader: React.FC<LoaderProps> = ({
  message,
  contents,
  leadBrand,
  pageName = undefined,
}) => {
  const settings = {
    infinite: true,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
  }

  const debounce = <A extends unknown[]>(
    callback: (...args: A) => unknown,
    msDelay: number
  ) => {
    let timer: NodeJS.Timeout | undefined

    return (...args: A) => {
      clearTimeout(timer)

      timer = setTimeout(() => {
        timer = undefined
        callback(...args)
      }, msDelay)
    }
  }

  useEffect(() => {
    document.body.style.backgroundColor = 'white'
  })

  useEffect(() => {
    console.log("firEvent('loaderScreen')", pageName)
    if (pageName)
      setTimeout(() => {
        fireEvent('loaderScreen', {
          trackingId: getTrackingId(),
          loaderScreenPage: pageName,
        })
      }, 500)
  }, [])

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  })

  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      })
    }, 100)

    window.addEventListener('resize', debouncedHandleResize)

    return () => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  })

  return (
    <Container>
      <div
        style={{ maxWidth: '800px', textAlign: 'center', alignItems: 'center' }}
      >
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <PulseLoader size={15} color={'#a0aec0'} loading={true} />
        </div>
        <p
          style={{
            color: '#222C69',
            fontSize: '12px',
            fontWeight: '550',
            paddingBottom: '15px',
          }}
        >
          POWERED BY ELITE INSURANCE PARTNERS
        </p>

        <p
          style={{
            color: '#222C69',
            fontSize: '32px',
            fontWeight: 'bold',
            marginBottom: '0px',
            textAlign: 'center',
          }}
        >
          DID YOU KNOW ?
        </p>

        <div
          style={{
            color: '#222c69',
            textAlign: 'center',
            maxWidth: '100vw',
            padding: '10px 30px 40px 30px',
          }}
        >
          <Slider {...settings}>
            {[
              '"Elite Insurance Partners has Helped Over 31,000+ Medicare Clients Save Hundreds of Dollars by Comparing Rates Online."',
              '"Our Medicare software will review your information and show the best plans for you online. You will be able to browse through the plans in detail and assess your savings. It’s 100% free!"',
            ].map((content) => (
              <div key={content}>
                <h4
                  style={{
                    fontFamily: '"Inter", sans-serif !important',
                    fontStyle: 'normal',
                    fontSize: '16px',
                    fontWeight: '550',
                    lineHeight: '24px',
                    letterSpacing: '0.3px',
                  }}
                >
                  {content}
                </h4>
              </div>
            ))}
          </Slider>
        </div>

        <GatheringInfoParagraph>
          {message ? message : 'ONE MOMENT PLEASE'}
        </GatheringInfoParagraph>
        <h3
          style={{
            color: '#686868',
            fontWeight: '600',
            fontSize: '18px',
          }}
        >
          Average savings of $597/year!
        </h3>
      </div>
    </Container>
  )
}

export default Loader
